import React from 'preact/compat';

const SendIcon: React.FC<{ size?: number }> = ({ size = 24 }) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width={size}
    height={size}
    viewBox='0 0 24 24'
    fill='none'
    stroke='currentColor'
    strokeWidth='2'
    strokeLinecap='round'
    strokeLinejoin='round'
  >
    <line
      x1='22'
      y1='2'
      x2='11'
      y2='13'
    ></line>
    <polygon points='22 2 15 22 11 13 2 9 22 2'></polygon>
  </svg>
);

export default SendIcon;
